import { render, staticRenderFns } from "./selectTJLX.vue?vue&type=template&id=1e923188"
import script from "./selectTJLX.vue?vue&type=script&lang=js"
export * from "./selectTJLX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports